<app-loading *ngIf="contentReady"></app-loading>
<div class="container mb-4">
  <div class="row d-flex justify-content-center align-items-center">
    <div class="col-lg-5 col-md-7 col-sm-12">
      <form class="from" [formGroup]="formInfo" (ngSubmit)="onSubmit()" #form="ngForm">
        <div class="form-group">
          <img *ngIf="isUpdatePage" style="width: 50px; height: 50px;" [src]="fixImgUrl(image)">
          <label class="label" for="media">

            {{ "AddImage" | translate }}
          </label>
          <br>
          <input type="file" id="media" (change)="onFileChange($event)" #fileInput [ngModel]="mediaFiles" formControlName="media" multiple />

        </div>
        <div class="form-group">
          <label class="label" for="Name">{{ "first_name" | translate }} </label>
          <input class="input" type="text" id="Name" formControlName="name" [ngModel]="first_name" placeholder="{{ 'first_name' | translate }}"
            [ngClass]="{
              'is-invalid':
              formInfo.controls.name.touched &&
              formInfo.controls.name.errors,
              'is-valid':
              formInfo.controls.name.touched &&
              !formInfo.controls.name.errors,
              'is-touched':
              formInfo.controls.name.untouched &&
              !formInfo.controls.name.errors,
          }" />
        </div>

        <div class="form-group">
          <label class="label" for="sname"> {{ 'last_name' | translate }} </label>
          <input class="input" type="text" [ngModel]="last_name" id="sname" formControlName="sname"
            placeholder="{{ 'last_name' | translate }}" [ngClass]="{
              'is-invalid':
              formInfo.controls.sname.touched &&
              formInfo.controls.sname.errors,
              'is-valid':
              formInfo.controls.sname.touched &&
              !formInfo.controls.sname.errors,
              'is-touched':
              formInfo.controls.sname.untouched &&
              !formInfo.controls.sname.errors,
          }" />
        </div>
        <div class="form-group">
          <label class="label" for="facebook"> {{ "facebook" | translate }} </label>
          <input class="input" type="text" [ngModel]="facebook_link" id="facebook" formControlName="facebook"
            placeholder="{{ 'facebook' | translate }}" [ngClass]="{
              'is-invalid':
              formInfo.controls.facebook.touched &&
              formInfo.controls.facebook.errors,
              'is-valid':
              formInfo.controls.facebook.touched &&
              !formInfo.controls.facebook.errors,
              'is-touched':
              formInfo.controls.facebook.untouched &&
              !formInfo.controls.facebook.errors,
          }" />
        </div>
        <div class="form-group">
          <label class="label" for="instagram">{{ "instagram" | translate }} </label>
          <input class="input" type="text" [ngModel]="instagram_link" id="instagram" formControlName="instagram"
            placeholder="{{ 'instagram' | translate }}" [ngClass]="{
              'is-invalid':
              formInfo.controls.instagram.touched &&
              formInfo.controls.instagram.errors,
              'is-valid':
              formInfo.controls.instagram.touched &&
              !formInfo.controls.instagram.errors,
              'is-touched':
              formInfo.controls.instagram.untouched &&
              !formInfo.controls.instagram.errors,
          }" />
        </div>
        <div class="form-group">
          <label class="label" for="tiktok">{{ "tiktok" | translate }} </label>
          <input class="input" [ngModel]="tiktok_link" type="text" id="tiktok" formControlName="tiktok"
            placeholder="{{ 'tiktok' | translate }} " [ngClass]="{
              'is-invalid':
              formInfo.controls.tiktok.touched &&
              formInfo.controls.tiktok.errors,
              'is-valid':
              formInfo.controls.tiktok.touched &&
              !formInfo.controls.tiktok.errors,
              'is-touched':
              formInfo.controls.tiktok.untouched &&
              !formInfo.controls.tiktok.errors,
          }" />
        </div>

        <div class="form-group">
          <label class="label" for="username">{{ 'username' | translate }} </label>
          <input class="input" type="text" [ngModel]="username" id="username" (ngModelChange)="saveEmail($event)" formControlName="username"
            placeholder="{{ 'username' | translate }}" [ngClass]="{
              'is-invalid':
              formInfo.controls.username.touched &&
              formInfo.controls.username.errors,
              'is-valid':
              formInfo.controls.username.touched &&
              formInfo.controls.username.errors,
              'is-touched':
              formInfo.controls.username.untouched &&
              formInfo.controls.username.errors,
          }" />
        </div>
        <div class="form-group">
          <label class="label" for="phone"> {{ "phone" | translate }} </label>
          <input class="input" type="text" [ngModel]="phone" id="phone" formControlName="phone" placeholder="{{ 'phone' | translate }}"
            [ngClass]="{
              'is-invalid':
              formInfo.controls.phone.touched &&
              formInfo.controls.phone.errors,
              'is-valid':
              formInfo.controls.phone.touched &&
              formInfo.controls.phone.errors == null ,
              'is-touched':
              formInfo.controls.phone.untouched &&
              formInfo.controls.phone.errors == null,
          }" />
        </div>

        <div class="form-group">
          <label class="label" for="Password">{{
            "Password" | translate
            }}</label>
          <input class="input" id="Password" type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="password" [ngModel]="read_password" placeholder="{{ 'Password' | translate }}" [ngClass]="{
              'is-invalid':
              formInfo.controls.password.touched &&
              formInfo.controls.password.errors,
              'is-valid':
              formInfo.controls.password.touched &&
              formInfo.controls.password.errors == null ,
              'is-touched':
              formInfo.controls.password.untouched &&
              formInfo.controls.password.errors == null,
          }" />
          <button type="button" class="hidePasswordBtn" (click)="togglePasswordVisibility()">
            @if(!isPasswordVisible){
            {{ "Show Password" | translate }}
            } @else {
            {{ "Hide Password" | translate }}
            }
          </button>
        </div>
        <div class="form-group">
          <label class="label" for="c_Password">{{
            "Confirm Password" | translate
            }}</label>
          <input class="input" id="c_Password" type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="c_Password" [ngModel]="read_password" placeholder="{{ 'Confirm Password' | translate }}" [ngClass]="{
              'is-invalid':
                formInfo.controls['c_Password'].touched &&
                formInfo.controls['c_Password'].errors,
              'is-valid':
                formInfo.controls['c_Password'].touched &&
                !formInfo.controls['c_Password'].errors
            }" />
          <button type="button" class="hidePasswordBtn" (click)="togglePasswordVisibility()">
            @if(!isPasswordVisible){
            {{ "Show Password" | translate }}
            } @else {
            {{ "Hide Password" | translate }}
            }
          </button>
        </div>
        <div class="form-group acconttype">
          <label class="label" for="Type">{{ 'user type' | translate }}</label>
          <div class="gap-4">

            <div  class="form-check">
              <input class="form-check-input" type="radio"  [(ngModel)]="type" formControlName="type" id="admin" value="1" />
              <label class="form-check-label fw-bold" for="admin">
                {{ 'admin' | translate }}
              </label>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="radio"  [(ngModel)]="type" formControlName="type" id="subadmin" value="6" />
              <label class="form-check-label fw-bold" for="subadmin">
                {{ 'subadmin' | translate }}
              </label>
            </div>
             <div class="form-check">
              <input class="form-check-input" type="radio"  [(ngModel)]="type" formControlName="type" id="Affiliation" value="2" />
              <label class="form-check-label fw-bold" for="Affiliation">
                {{"financial" | translate }}
              </label>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="radio"  [(ngModel)]="type" formControlName="type" id="subadmin" value="7" />
              <label class="form-check-label fw-bold" for="subadmin">
                موظف
              </label>
            </div>
          </div>
        </div>
     <div class="form-group acconttype">
          <label class="label" for="Type">افتح ارقام التليفونات</label>
          <div class="gap-4">

            <div class="form-check">
              <input class="form-check-input" type="radio"  formControlName="has_access_to_phone_numbers"  id="yes" value="1" />
              <label class="form-check-label fw-bold" for="yes">
                اه
              </label>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="radio"   formControlName="has_access_to_phone_numbers" id="no" value="0" />
              <label class="form-check-label fw-bold" for="no">
               لا
              </label>
            </div>
          
          </div>
        </div>
              <div class="form-group access-pages">
          <label class="label fw-bold">حق الوصول للصفحات</label>
          <div class="gap-4">

            <div class="form-check" *ngFor="let page of accessPagesList">
              <input class="form-check-input" type="checkbox" [value]="page.value" (change)="onCheckboxChange($event)"
                [checked]="accessPages.includes(page.value)" />
              <label class="form-check-label fw-bold">
                {{ page.label | translate }}
              </label>
            </div>

          </div>
        </div>
        <hr class="line" width="100%" size="3" noshade />

        <button type="submit" class="submit-btn accont" [disabled]="formInfo.invalid">
              @if(isUpdatePage){
          {{ 'Edit' | translate }}
          } @else {
          {{ 'Create' | translate }}
          }
        </button>

      </form>
    </div>
  </div>
</div>